import { Component, } from '@angular/core';
import { CommunicationService } from './../../shared/services/communication.service';
import { Storyboard } from './../../models/storyboards/storyboards.model';

import { ApiService } from './../../shared/services/api.service';
import { ListBase } from './../../shared/components/base/list/list.base.component';

@Component({
  selector: 'swb-storyboards-list',
  templateUrl: './../../shared/components/base/list/list.base.component.html' // TODO: tile list template
})
export class StoryboardsListComponent extends ListBase<Storyboard> {

  public url = 'storyboards';
  public routePrefix = 'storyboards';

  constructor(
    _apiService: ApiService,
    _communicationService: CommunicationService
  ) {
    super(
      _apiService,
      _communicationService
    );
  }
}
